import React from 'react';
import {Col, Container, Row} from 'reactstrap';

import {
  PropertyContainer,
  PropertyCount,
  PropertyCountDescr,
  PropertyDescr,
  PropertyIcon,
  PropertySimpleIcon,
  PropertyWrapper,
  SmallTitle,
} from './styles/PropertyStyles';
import {PROPERTY} from '../../../../../assets/images/landing';

const PropertyComponent = () => {
  return (
    <PropertyContainer className='propertyContainer'>
      <Container className="text-center">
        <PropertyDescr>
          Results That Speak For Themselves
        </PropertyDescr>

        <Row>
          <Col xs='12' md='6' lg='3' className='text-center'>
            <PropertyIcon>
              <PropertySimpleIcon src={PROPERTY.PropertyHome} alt=''/>
            </PropertyIcon>
            <PropertyWrapper>
              <PropertyCount>20,000+</PropertyCount>
              <br/>
              <PropertyCountDescr>Properties Showcased Nationwide</PropertyCountDescr>
            </PropertyWrapper>
          </Col>
          <Col xs='12' md='6' lg='3' className='text-center'>
            <PropertyIcon>
              <PropertySimpleIcon src={PROPERTY.Rectangle} alt=''/>
            </PropertyIcon>
            <PropertyWrapper>
              <PropertyCount>600,000+</PropertyCount>
              <br/>
              <PropertyCountDescr>
                Photos, Videos, and Interactive Tours
              </PropertyCountDescr>
            </PropertyWrapper>
          </Col>
          <Col xs='12' md='6' lg='3' className='text-center'>
            <PropertyIcon>
              <PropertySimpleIcon src={PROPERTY.Happy} alt=''/>
            </PropertyIcon>
            <PropertyWrapper>
              <PropertyCount>2,000+</PropertyCount>
              <br/>
              <PropertyCountDescr>Happy Clients Who Trust Us For Consistent Results</PropertyCountDescr>
            </PropertyWrapper>
          </Col>
          <Col xs='12' md='6' lg='3' className='text-center'>
            <PropertyIcon>
              <PropertySimpleIcon src={PROPERTY.Stock} alt=''/>
            </PropertyIcon>
            <PropertyWrapper>
              <PropertyCount>+$8 Billion</PropertyCount>
              <br/>
              <PropertyCountDescr>in Estimated Property Value Captured</PropertyCountDescr>
            </PropertyWrapper>
          </Col>
        </Row>
      </Container>
    </PropertyContainer>
  );
};

export default PropertyComponent;
